"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var loadInitialProps_1 = require("../common/loadInitialProps");
var utils_1 = require("../utils");
function isDataEmpty(val) {
    return val && utils_1.isObject(val) ? Object.keys(val).length === 0 : true;
}
var rootComponentTokens = {
    notLoaded: null,
    loadedAndMissing: React.Fragment,
};
var After = /** @class */ (function (_super) {
    __extends(After, _super);
    function After(props) {
        var _this = _super.call(this, props) || this;
        _this.prefetch = function (pathname) {
            loadInitialProps_1.loadInitialProps(_this.props.routes, pathname, {
                history: _this.props.history,
            })
                .then(function (_a) {
                var _b;
                var data = _a.data, rootProps = _a.rootProps, _c = _a.RootComponent, RootComponent = _c === void 0 ? rootComponentTokens.loadedAndMissing : _c;
                _this.prefetched = __assign(__assign({}, _this.prefetched), (_b = {}, _b[pathname] = {
                    data: data,
                    rootProps: rootProps,
                    RootComponent: RootComponent,
                }, _b));
            })
                .catch(function (e) {
                // @todo we should more cleverly handle errors?
                console.error(e);
            });
        };
        var data = props.data;
        _this.state = {
            data: data,
            dataLoaded: !isDataEmpty(data),
            previousLocation: null,
            rootProps: null,
            RootComponent: rootComponentTokens.notLoaded,
        };
        _this.prefetched = {};
        return _this;
    }
    After.prototype.componentDidMount = function () {
        // In case of client-side rendering we don't have available data from server, so
        // we must load them initially.
        // Also see componentDidUpdate, which handles loading data for new page navigation.
        if (isDataEmpty(this.props.data)) {
            this.loadData(this.props);
        }
    };
    After.prototype.componentDidUpdate = function (prevProps) {
        // NoteReview(simon): should only care about changed paths?
        var didNavigate = this.props.location !== prevProps.location;
        if (didNavigate) {
            // new page => scroll to top (react-router doesn't do it for us)
            window.scrollTo(0, 0);
            // save the location so we can render the old screen
            this.setState(this.resetLocationState(this.props));
            this.loadData(this.props);
        }
    };
    After.prototype.resetLocationState = function (props) {
        // Reset state for new location
        return {
            previousLocation: props.location,
            data: null,
            dataLoaded: false,
            // we want to keep the root compnent unless other page has different one
            RootComponent: this.state.RootComponent,
            rootProps: this.state.rootProps,
        };
    };
    After.prototype.loadData = function (nextProps) {
        var _this = this;
        var data = nextProps.data, match = nextProps.match, routes = nextProps.routes, history = nextProps.history, location = nextProps.location, staticContext = nextProps.staticContext, rest = __rest(nextProps, ["data", "match", "routes", "history", "location", "staticContext"]);
        loadInitialProps_1.loadInitialProps(this.props.routes, location.pathname, __assign({ location: location, history: nextProps.history }, rest))
            .then(function (_a) {
            var data = _a.data, rootProps = _a.rootProps, _b = _a.RootComponent, RootComponent = _b === void 0 ? rootComponentTokens.loadedAndMissing : _b;
            // step: ignore data loaded for previous page after page transition. This can happen when page A takes
            // longer time to load than current page B. It re-renders the After component (page) with different data,
            // but keeps the path/location.
            if (_this.props.location !== location) {
                return;
            }
            _this.setState({
                previousLocation: null,
                data: data,
                dataLoaded: true,
                rootProps: rootProps,
                RootComponent: RootComponent,
            });
        })
            .catch(function (e) {
            // @todo we should more cleverly handle errors?
            console.error(e);
        });
    };
    After.prototype.render = function () {
        var _this = this;
        var _a = this.state, previousLocation = _a.previousLocation, dataLoaded = _a.dataLoaded;
        var location = this.props.location;
        var pathname = location.pathname;
        var prefetchedForPage = this.prefetched[pathname] || {};
        var initialData = prefetchedForPage.data || this.state.data;
        var RootComponent = prefetchedForPage.RootComponent || this.state.RootComponent || React.Fragment;
        // Note(null): Fragment cannot accept any props but key and children
        var rootProps = RootComponent === React.Fragment
            ? null
            : __assign(__assign({}, (prefetchedForPage.rootProps || this.state.rootProps)), { afterMeta: { pageLoaded: dataLoaded } });
        var afterMeta = {
            dataLoaded: dataLoaded,
        };
        return (React.createElement(RootComponent, __assign({}, rootProps),
            React.createElement(react_router_dom_1.Switch, null, this.props.routes.map(function (r, i) { return (React.createElement(react_router_dom_1.Route, { key: "route--" + i, path: r.path, exact: r.exact, location: previousLocation || location, render: function (props) {
                    return React.createElement(r.component, __assign(__assign({}, initialData), { afterMeta: afterMeta, history: props.history, location: previousLocation || location, match: props.match, prefetch: _this.prefetch }));
                } })); }))));
    };
    return After;
}(React.Component));
exports.default = react_router_dom_1.withRouter(After);
//# sourceMappingURL=After.js.map